<template>
  <div>
    <article class="bg-w">
      <report-item v-for="(item, name) in seperate" :item="item" :name="name" :key="name"></report-item>
    </article>
  </div>
</template>
<script>
import ReportItem from './ReportItem'
import { evaluate } from './restConfig'
export default {
  components: {
    ReportItem
  },
  data() {
    return {
      report: {}
    }
  },
  created() {
    let type = 'default'
    // 请求接口说明：
    // 线索询价和车辆询价来路的：查看都是调用 default 的请求接口
    // 询价撮合、流拍撮合：auctionMatch、enquiryMatch、outbound、outBoundReview
    // 拍卖来路：aution
    const fromArr = ['auctionMatch', 'enquiryMatch', 'auction', 'outbound', 'outBoundReview', 'reference', 'ownbrand']
    // 增加参数 default 来区别来源页面 是从全部车辆拍卖页面来的 还是询价页面来的
    if (this.$route.query.default !== '1') {
      fromArr.map((item) => {
        if (item === this.$route.params.source) {
          type = item
        }
      })
    }
    this.getData(type)
  },
  methods: {
    async getData(type) {
      let id = this.$route.params.id
      let _this = this
      const sourctType = {
        'auctionMatch': function() {
          return _this.$rest.match.getMatchCarDetail(null, id)
        },
        'enquiryMatch': function() {
          let postLink = `${id}/match_car_details`
          return _this.$rest.match.getEnquiryCarDetail(null, postLink)
        },
        'auction': function() {
          return _this.$rest.auction.getAuctionDetail(null, `${id}/detail`)
        },
        // 报废、零售、批售、特殊出库的查看报告
        'outbound': function() {
          return _this.$rest.outBound.getOutBoundCarDetail(null, `outbound_car_detail/${id}`)
        },
        // 出库审核中 查看报告
        'outBoundReview': function() {
          return _this.$rest.outBound.getOutBoundCarDetail(null, `outbound_requests/${id}/car_details`)
        },
        'reference': function() {
          return _this.$rest.usedCar.getReferenceCarDetail(null, `${id}`)
        },
        'ownbrand': function () {
          return _this.$rest.usedCar.getSharedCarDetail(null, `${id}`)
        },
        'default': function () {
          let source = _this.$route.params.source
          let urlLeft = evaluate[source](id)
          return _this.$rest.carInfo.query(null, urlLeft)
        }
      }
      let res = await sourctType[type]()
      if (res.code === 0) {
        this.report = type === 'default' ? res.data.inspections : res.data.auction_car.inspections
      } else {
        this.showToast(res.message)
      }
    }
  },
  computed: {
    seperate() {
      let itemName = {
        skeletonDamage: ['右B柱', '右C柱', '备胎室', '左C柱', '左B柱', '左A柱', '车顶', '车底板', '左前避震器座', '左前纵梁', '前横梁', '右前纵梁', '水箱支架', '右前避震器座', '防火墙', '右A柱'], // 骨架损伤
        metalRepair: ['引擎盖', '车顶', '后行李箱盖', '左前叶子板', '左前门', '左后门', '左后叶子板', '右前叶子板', '右前门', '右后门', '右后叶子板'], // 钣金修复
        appearanceDamage: ['前保险杠', '引擎盖', '右前叶子板', '右后视镜', '右前门', '右后门', '右后叶子板', '左后门', '左前门', '左后视镜', '左前叶子板', '左前大灯', '右前大灯', '右前轮毂', '右前轮胎', '右裙边', '右后轮毂', '右后轮胎', '右后大灯', '后保险杠', '后行李箱盖', '左后大灯', '左后叶子板', '左后轮胎', '左后轮毂', '左裙边', '左前轮胎', '左前轮毂', '前挡风玻璃', '后挡风玻璃', '随车工具', '备胎'], // 外观损伤
        waterCheck: ['前横梁', '备胎室', '安全带', '顶蓬', '地毯', '音响', '保险盒', 'EUC接口处', '点烟器底座', '烟灰缸底座', '驾驶舱和后备箱内', '后排座椅坐垫底部'], // 泡水检测
        fireCheck: ['发动机线束及橡胶制品', '车辆覆盖件及驾驶舱'], // 火烧检测
        inDecoration: ['座椅', '换挡杆', '安全带', '顶蓬', '门饰板', '地毯', '中央控制台', '方向盘'], // 内饰
        machines: ['发动机', '变速箱', '转向机', '减震器', '消音器'], // 机械
        appliances: ['电动后视镜', '音响', '导航', '电动车窗', '天窗', '空调', '仪表灯'] // 电器
      }
      let damageList = {}
      let report = this.report
      let reportList = []
      Object.keys(report).forEach(rv => {
        reportList = reportList.concat(report[rv])
      })
      Object.keys(itemName).forEach(v => {
        damageList[v] = reportList.filter(rlv => {
          return itemName[v].some(inv => {
            return inv === rlv.note
          })
        })
      })
      return damageList
    }
  }
}
</script>
<style lang="less">
</style>
